export default "__VITE_ASSET__BGL6FlJn__"